import { Copy } from '@sleepstation/components-copy'
import { constrainNarrow } from '@sleepstation/style-mixins'
import styled from 'styled-components'

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------

const ConstrainedCopy = styled(Copy)`
  > *:not(.breakout) {
    /* Target all items that are not broken out. This will include all markdown-rendered content like paragraphs and titles. */
    ${constrainNarrow()}
  }
`

export default ConstrainedCopy
